const CASH_DENOMINATIONS = [
  1_000,
  2_000,
  5_000,
  10_000,
  20_000,
  50_000,
  100_000,
  200_000,
  500_000,
  1_000_000,
];

export const normalizeCashAmount = (value: unknown): number => {
  const parsedValue = Number(value);

  if (!Number.isFinite(parsedValue) || parsedValue <= 0) {
    return 0;
  }

  return Math.floor(parsedValue);
};

export const appendCashDigit = (currentAmount: unknown, digit: number): number => {
  const normalizedDigit = Math.max(0, Math.min(9, Math.trunc(digit)));
  const currentValue = normalizeCashAmount(currentAmount);
  const nextValue = currentValue * 10 + normalizedDigit;

  return Number.isSafeInteger(nextValue) ? nextValue : currentValue;
};

export const removeLastCashDigit = (currentAmount: unknown): number => {
  return Math.floor(normalizeCashAmount(currentAmount) / 10);
};

export const getSuggestedCashAmount = (totalAmount: unknown): number => {
  const total = Math.ceil(Math.max(0, Number(totalAmount) || 0));

  if (total === 0) {
    return 0;
  }

  const matchingDenomination = CASH_DENOMINATIONS.find(
    (denomination) => denomination >= total
  );

  if (matchingDenomination) {
    return matchingDenomination;
  }

  return Math.ceil(total / 100_000) * 100_000;
};

interface CheckoutActionPresentationInput {
  cartItemCount: number;
  totalAmount: number;
  paidAmount: number;
  dueAmount: number;
}

interface CheckoutActionPresentation {
  label: string;
  hint: string | null;
}

const formatCfaAmount = (value: number): string => {
  const normalizedValue = Math.max(0, Number(value) || 0);

  return `${normalizedValue.toLocaleString("fr-FR", {
    maximumFractionDigits: 2,
  })} CFA`;
};

export const getCheckoutActionPresentation = ({
  cartItemCount,
  totalAmount,
  paidAmount,
  dueAmount,
}: CheckoutActionPresentationInput): CheckoutActionPresentation => {
  if (cartItemCount <= 0) {
    return {
      label: "Panier vide",
      hint: null,
    };
  }

  if (paidAmount <= 0) {
    return {
      label: `Enregistrer la vente non payée · ${formatCfaAmount(totalAmount)}`,
      hint: "Aucun montant reçu : le solde restera dû.",
    };
  }

  if (dueAmount > 0) {
    return {
      label: `Encaisser ${formatCfaAmount(paidAmount)} · reste ${formatCfaAmount(
        dueAmount
      )}`,
      hint: null,
    };
  }

  return {
    label: `Encaisser ${formatCfaAmount(totalAmount)}`,
    hint: null,
  };
};
